import { z } from 'zod';
import { OrderModifierSchema } from './OrderModifier';

export const OrderModifierGroupSchema = z.object({
    // 0 = UNRESOLVED (see OrderModifier.ts), the `menuItemId` sentinel.
    modifierGroupId: z.number().int().nonnegative(),
    name: z.string().min(1),
    modifiers: z.array(OrderModifierSchema).default([]),
});

export const OrderModifierGroupDataSchema = z.object({
    // 0 = UNRESOLVED (see OrderModifier.ts), the `menuItemId` sentinel.
    modifierGroupId: z.number().int().nonnegative(),
    name: z.string().min(1),
    modifiers: z.array(OrderModifierSchema).optional().default([]),
});

export type OrderModifierGroupSchemaType = z.infer<typeof OrderModifierGroupSchema>;
export type OrderModifierGroupDataSchemaType = z.infer<typeof OrderModifierGroupDataSchema>;
